export default __webpack_public_path__ + "static/media/espoch.547c1ec1.svg";